import { JsonODataModel, ODataModel, ODataObject } from '../interfaces/odata-model.interface';
import { JsonUtilities } from '../utilities/json-utilities';

export class DisplayDecorator<T extends ODataModel> implements ODataModel {
    public constructor(
        public displayName: string,
        public model: T,
    ) {}

    public get value(): T['value'] {
        return this.model.value;
    }
    public set value(newValue: T['value']) {
        this.model.value = newValue;
    }
    public get name(): string {
        return this.model.name;
    }
    public set name(newName: string) {
        this.model.name = newName;
    }
    public get options(): T['options'] {
        return this.model.options;
    }
    public set options(newOptions: T['options']) {
        this.model.options = newOptions;
    }

    public getOutModel(): ODataDisplayDecoratorOutModel {
        return this.model.getOutModel();
    }
}

export class DisplayDecoratorFromJson<T extends ODataModel> extends DisplayDecorator<T> {
    public constructor(type: new (...args: unknown[]) => T, data: JsonDisplayDecorator) {
        super(data.displayName, JsonUtilities.fromJson<T>(type, data.model));
    }
}

export interface JsonDisplayDecorator {
    displayName: string;
    model: JsonODataModel;
}

// need here type because empty interfaces are not allowed
export type ODataDisplayDecoratorOutModel = ODataObject;
